import { Component } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {FormLabelDirective} from "../../../core/directives/form-label.directive";
import {FormInputTextDirective} from "../../../core/directives/form-input-text.directive";
import {Router, RouterLink} from "@angular/router";
import {AuthService} from "../../../services/auth.service";
import {environment} from "../../../../environments/environment";
import {AuthStateService} from "../../../core/states/auth-state.service";
import {GlobalConfig, ToastrService} from "ngx-toastr";
import {AlertToast} from "../../../shared/notifications/alert.toast";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    FormsModule,
    FormLabelDirective,
    FormInputTextDirective,
    RouterLink
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  environment = environment;
  options: GlobalConfig;
  loading: boolean = false;

  email: string = "";
  password: string = "";

  // Selección de sucursal (operadoras con varias sucursales).
  requiresOfficeSelection: boolean = false;
  offices: any[] = [];
  selectedOfficeId: number | null = null;
  officeDropdownOpen: boolean = false;

  get selectedOfficeName(): string {
    return this.offices.find(o => o.id === this.selectedOfficeId)?.name || 'Selecciona una sucursal';
  }

  toggleOfficeDropdown(): void {
    this.officeDropdownOpen = !this.officeDropdownOpen;
  }

  selectOffice(office: any): void {
    this.selectedOfficeId = office.id;
    this.officeDropdownOpen = false;
  }

  constructor(private authService: AuthService,
              private authStateService: AuthStateService,
              private router: Router,
              private toastr: ToastrService,
              private spinner: NgxSpinnerService,) {
    this.options = this.toastr.toastrConfig;
    if (!environment.production) {
      this.email = "alberto@deceroconsulting.com"
      this.password = 'password'
    }
  }

  loginClick() {
    this.loadingFunc(true);
    this.authService.signIn(this.email, this.password, this.selectedOfficeId).subscribe({
      next: data => {
        // El operador con varias sucursales debe elegir una antes de entrar.
        if (data.data?.requires_office_selection) {
          this.offices = data.data.offices ?? [];
          this.requiresOfficeSelection = true;
          this.selectedOfficeId = this.offices.length ? this.offices[0].id : null;
          this.loadingFunc(false);
          return;
        }

        if (data.data) {
          this.authStateService.setUser(data.data);
          this.router.navigate([this.authStateService.landingRoute()]);
        }
        else {
          this.authStateService.setUser(null);
        }
        this.loadingFunc(false);
      },
      error: err => {
        this.loginErrorToast('Usuario incorrecto', err.error.message);
        this.loadingFunc(false);
      }
    })
  }

  cancelOfficeSelection() {
    this.requiresOfficeSelection = false;
    this.offices = [];
    this.selectedOfficeId = null;
  }

  loginErrorToast(title: string, message: string) {
    const opt: any = this.options;
    opt.toastComponent = AlertToast;
    opt.progressBar = true;
    opt.type = 'error';
    opt.toastClass = 'toast';
    this.toastr.show(message, title, opt);
  }

  loadingFunc(loading: boolean) {
    this.loading = loading;
    loading ? this.spinner.show() : this.spinner.hide();
  }
}
